import Link from '@atlaskit/link';
import SectionMessage from '@atlaskit/section-message';
import MotionResizingWidth from "../../../../../../packages/design-system/motion/examples/constellation/motion-resizing-width";
import MotionResizingHeightNew from "../../../../../../packages/design-system/motion/examples/constellation/motion-resizing-height-new";
import MotionResizingBoth from "../../../../../../packages/design-system/motion/examples/constellation/motion-resizing-both";
import MotionResizingHeight from "../../../../../../packages/design-system/motion/examples/constellation/motion-resizing-height";
import RAW_UNSAFE_atlaskitSLASHlink from "!!raw-loader!@atlaskit/link";
import RAW_UNSAFE_atlaskitSLASHsection_message from "!!raw-loader!@atlaskit/section-message";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_resizing_width from "!!raw-loader!../../../../../../packages/design-system/motion/examples/constellation/motion-resizing-width";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_resizing_height_new from "!!raw-loader!../../../../../../packages/design-system/motion/examples/constellation/motion-resizing-height-new";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_resizing_both from "!!raw-loader!../../../../../../packages/design-system/motion/examples/constellation/motion-resizing-both";
import RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_resizing_height from "!!raw-loader!../../../../../../packages/design-system/motion/examples/constellation/motion-resizing-height";
import * as React from 'react';
export default {
  Link,
  SectionMessage,
  MotionResizingWidth,
  MotionResizingHeightNew,
  MotionResizingBoth,
  MotionResizingHeight,
  RAW_UNSAFE_atlaskitSLASHlink,
  RAW_UNSAFE_atlaskitSLASHsection_message,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_resizing_width,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_resizing_height_new,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_resizing_both,
  RAW_UNSAFEUPUPSLASHUPUPSLASHexamplesSLASHconstellationSLASHmotion_resizing_height,
  React
};